/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

//load REVIEW DYNAMICALLY
document.addEventListener('DOMContentLoaded', function () {
    // Function to extract and update WebwinkelKeur ratings
    function extractWebwinkelKeurRatings() {
        try {
            // Find the JSON-LD script containing WebwinkelKeur data
            const jsonLdScript = document.querySelectorAll('script[type="application/ld+json"]');
            jsonLdScript.forEach(script => {
                const jsonData = JSON.parse(script.textContent);
                
                // Check if the data contains the expected rating information
                if (jsonData.aggregateRating) {
                    const amount = jsonData.aggregateRating.reviewCount;
                    const rating = jsonData.aggregateRating.ratingValue.toFixed(1).replace('.', ',');
                    
                    // Update elements with the rating data
                    document.querySelectorAll('[data-rating-total]').forEach(el => el.innerHTML = amount);
                    document.querySelectorAll('[data-rating-average]').forEach(el => el.innerHTML = rating);
                    
                    console.log('WebwinkelKeur ratings loaded from JSON-LD:', {
                        reviewCount: amount,
                        rating: rating
                    });
                }
            });
        } catch (error) {
            console.error('Error extracting WebwinkelKeur data:', error);
        }
    }

    // Check if the WebwinkelKeur data is already loaded
    if (window._webwinkelkeur_rich_snippet_loaded) {
        extractWebwinkelKeurRatings();
    } else {
        if (document.querySelector('.wwk-sidebar-popup_rating')) {
            document.querySelectorAll('[data-rating-average]').forEach(el => el.innerHTML = document.querySelector('.wwk-sidebar-popup_rating').innerHTML);
            document.querySelectorAll('[data-rating-total]').forEach(el => el.innerHTML = document.querySelector('.wwk-sidebar-popup__reviews_count').innerHTML.replace('(', '').replace(')', ''));
        }
            // Set up a watcher to check when the WebwinkelKeur data becomes available
        let checkInterval = setInterval(function() {
            if (window._webwinkelkeur_rich_snippet_loaded) {
                extractWebwinkelKeurRatings();
                clearInterval(checkInterval);
            }
        }, 100);
        
        // Set a timeout to stop checking after 10 seconds to prevent infinite checking
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 10000);
    }
});

// wwk-sidebar-popup_rating
// wwk-sidebar-popup__reviews_count

const observer = new MutationObserver(() => {
        const container = document.querySelector('.inject-quiz-banner');
        const container_second = document.querySelector('.inject-quiz-banner-b');
        const container_third = document.querySelector('.inject-quiz-banner-c');
        let section_id = null;
        let section = null;

        const handle_banner = document.querySelector('.article_quiz_banner').dataset.handle;

          if (!handle_banner) {
            console.error('Missing data-handle attribute on blog-product-section');
          }

        if (container || container_second || container_third) {
          observer.disconnect();
          if(container){section_id = 'blog-quiz-banner'; section = '.inject-quiz-banner';}
          else if(container_second){section_id = 'blog-quiz-banner-variant-b';section = '.inject-quiz-banner-b';}
          else if(container_third){section_id = 'blog-quiz-banner-variant-c';section = '.inject-quiz-banner-c';}
      
      

             fetch(`/blogs/${handle_banner}?section_id=${section_id}`)
              .then((response) => response.text())
              .then((responseText) => {
                
                const QuizViewhtml = new DOMParser().parseFromString(responseText, 'text/html')  ;
                const source = QuizViewhtml.querySelector('.js-inner-source');
                const source_second = QuizViewhtml.querySelector('.js-sidebar-quiz');
                document.querySelector(section).innerHTML = source.innerHTML;
                document.querySelector('.js-quiz-side-banner').innerHTML = source_second.innerHTML;
              });
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      
setTimeout(()=>{observer.disconnect();},5000);

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const containers = document.querySelectorAll(".block-product-section");
    if (containers.length > 0) {
      containers.forEach((container) => {
        if (container.dataset.processed) return;
        const productId = container.getAttribute("data-product-id");
        container.dataset.processed = true;

        if (productId === "1") {
          fetch("/?sections=new-blog-product", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              const sectionHtml = data["new-blog-product"];
              if (sectionHtml) {
                const parser = new DOMParser();
                const quickViewHtml = parser.parseFromString(
                  sectionHtml,
                  "text/html"
                );
                const source = quickViewHtml.querySelector(".feature-product");
                if (source) {
                  container.innerHTML = source.innerHTML;
                }
              }
            })
            .catch((error) => {
              console.error("Error loading product 1:", error);
            });
        } else if (productId === "2") {
          fetch("/?sections=new-blog-product-two", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              const sectionHtml = data["new-blog-product-two"];
              if (sectionHtml) {
                const parser = new DOMParser();
                const quickViewHtml = parser.parseFromString(
                  sectionHtml,
                  "text/html"
                );
                const source = quickViewHtml.querySelector(".feature-product");
                if (source) {
                  container.innerHTML = source.innerHTML;
                }
              }
            })
            .catch((error) => {
              console.error("Error loading product 2:", error);
            });
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  setTimeout(() => {
    observer.disconnect();
  }, 5000);
});


class CartRecommendedSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  destroySwiper() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');

          this.swiperInstance = null;

          return null;
        }

        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);

        this.swiperInstance = null; // Fallback
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }

  initSwiper() {
    this.swiperInstance = new Swiper('.cart-recommendation-mobile', {
      slidesPerView: 1.26,
      spaceBetween: 24,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

customElements.define('cart-recommended-swiper', CartRecommendedSwiper);

class CartReviewWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const storedRTotal = localStorage.getItem('ntljkp-rtotal');
    const storedRAverage = localStorage.getItem('ntljkp-raverage');

    document.getElementById('mini-cart-average').innerHTML = storedRAverage;
    document.getElementById(
      'mini-cart-total-id'
    ).innerHTML = `(${storedRTotal})`;
  }
}

customElements.define('cart-review-widget', CartReviewWidget);